/**
 * Checks if a given value is a boolean.
 */
export function isBoolean(val) {
    return val === true || val === false;
}
